import styled from 'styled-components';

export const SectionTitle = styled.div`
  margin-top: 20px;
  padding: 15px 0;
  color: ${({ theme }) => theme.baseBlue.a6};
  font-weight: 600;
  display: flex;
  line-height: 26px;
  min-height: 26px;
  box-sizing: content-box;
  align-items: center;
  > span {
    margin-right: 5px;
  }
`;

export const FieldWrapper = styled.div`
  margin-bottom: 15px;
`;
